import React from 'react';

interface PageHeadingProps {
  className?: string,
  left?: React.ReactNode,
  center?: React.ReactNode,
  right?: React.ReactNode,
}

// Gutters match PageBody so the title lines up with the content beneath it.
// The h1 no longer needs a font-weight override: the base layer now gives it an
// explicit 32px/700, and the icon inherits its color from the heading rather
// than being forced to primary.
const pageHeadingClasses = [
  // box-border: without it w-full is CONTENT width, so the px padding pushes
  // the border box past the main column and hands .page a horizontal scroll
  // whenever the column is under max-w + padding (~1920px windows).
  'mx-auto box-border flex w-full max-w-[1600px] items-center py-5 px-4 sm:px-6',
  '[&_h1]:inline-flex [&_h1]:items-center',
  '[&_h1_.icon]:mr-2.5 [&_h1_.icon]:text-fg-3',
  '[&_h1_.icon_svg]:w-6',
  '[&_.left]:mr-auto [&_.left]:flex [&_.left]:flex-col [&_.left]:justify-center [&_.left]:min-w-0',
  '[&_.right]:ml-auto [&_.right]:flex [&_.right]:items-center [&_.right]:gap-2',
  'mobile:py-4 mobile:px-4',
  'mobile:[&_h1]:text-[1.65rem]',
  'mobile:[&_h1_.icon]:mr-1.5',
  'mobile:[&_h1_.icon_svg]:w-5',
].join(' ');

export const PageHeading = (props: PageHeadingProps) => {
  return (
    <div className={`page-heading ${pageHeadingClasses}${props.className ? ` ${props.className}` : ''}`}>
      {props.left && <div className="left">{props.left}</div>}
      {props.center && <div className="center">{props.center}</div>}
      {props.right && <div className="right">{props.right}</div>}
    </div>
  );
};
